import { render, staticRenderFns } from "./CRMultiTextInput.vue?vue&type=template&id=0cbe2fcc"
import script from "./CRMultiTextInput.vue?vue&type=script&lang=js"
export * from "./CRMultiTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports